var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('f-confirmation'),_c('app-bar'),_c('v-main',{staticClass:"grey lighten-4 partnerAffiliateLayout",attrs:{"fluid":""}},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }